import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";

const useStyles = makeStyles((theme) => ({
    page: {
        marginLeft: "120px",
        marginRight: "40px",
        marginTop: "20px",
        textAlign: "left",
        display: "flex",
        flexDirection: "column",
        minHeight: "600px",
    },
    header: {
        fontWeight: "400",
        letterSpacing: "1px",
        paddingRight: "20px",
        verticalAlign: "text-top",
        color: theme.brand.LYSAGHT ? theme.palette.primary.light : Palette.Control.DarkGrey,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.brand.LYSAGHT ? "24pt" : "18pt",
        textTransform: theme.brand.LYSAGHT ? "uppercase" : "capitalize",
        fontWeight: theme.brand.LYSAGHT ? "800" : "inherit",
    },
}));

export default function NewsMain(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    return (
        <div className={classes.page}>
            <div style={{ marginBottom: "10px" }}>
                <span className={classes.header}>News</span>
            </div>
        </div>
    );
}
